<template>
  <div class="preview-container flex">
    <!-- 左侧导航 -->
    <div class="left-nav w-64 bg-white border-r border-gray-200">
      <navigation-panel
        :data="mergedData"
        :active-section="activeSection"
        @section-change="handleSectionChange"
      />
    </div>

    <!-- 右侧全数据展示 -->
    <div class="right-content flex-1 bg-gray-50">
      <full-data-panel
        ref="fullDataPanel"
        :data="mergedData"
        :currency="currency"
        :active-section="activeSection"
        :enumConstants="enumConstants"
        :currentAccount="currentAccount"
        @update-campaign="handleUpdateCampaign"
        @update-campaign-data="handleUpdateCampaignData"
        @update-adgroup="handleUpdateAdGroup"
        @delete-adgroup="handleDeleteAdGroup"
        @update-ad="handleUpdateAd"
        @delete-ad="handleDeleteAd"
        @add-adgroup="handleAddAdGroup"
        @add-ad="handleAddAd"
      />
    </div>
  </div>
</template>

<script>
import NavigationPanel from './previewComponents/NavigationPanel.vue';
import FullDataPanel from './previewComponents/FullDataPanel.vue';

export default {
  name: 'Preview',
  components: {
    NavigationPanel,
    FullDataPanel,
  },
  props: {
    splitTableMsg: {
      type: Object,
      default: () => ({
        name: '',
        adGroups: [],
      }),
    },
    currency: {
      type: String,
      default: 'USD',
    },
    enumConstants: {
      type: Object,
      default: () => ({}),
    },
    currentAccount: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      activeSection: 'campaign', // campaign, adGroup-{index}
      localData: null, // 本地数据副本
      // 默认示例数据
      defaultData: {
        userId: 633396,
        name: 'KR|KR|KR#1004983922#精緻型男塑身衣『餂12.29-18:5』',
        optimizationGoal: '',
        type: 'DEMAND_GEN',
        promoteInfo: {
          utmSourceConfig: 'SHOP_PLUS',
          apiLanguageId: null,
          apiLocationId: null,
          promotionLink: 'https://shopx4-master.giikin.com/detail/xvoYgWLxFtvvSU4n1RHF',
          sale: {
            id: 1004983922,
            saleId: 1004983922,
            title: '研发-测试#多规格地址',
            price: '99603231.00',
            specialPrice: '49801231',
            currencyId: 14,
            productId: 1038149,
            productName: '精緻型男塑身衣',
            domain: null,
            seoUrl: null,
            imageUrl: 'https://nonwebp.compgoo.com/ueditor/20210125/12c7ab818441fab02a837170ec1f170b.jpg',
            areaId: 139,
            orgCode: null,
            uploader: 631576,
            langId: 9,
            langCode: null,
            status: 1,
            currency: 'SAR',
            stop_production: null,
          },
          site: {
            name: 'shopx4-master.giikin.com',
            saleName: '王莆元测试店铺2',
            marketId: 8,
            countryName: null,
            langId: 5,
            langCode: null,
            langName: null,
            areaId: 139,
            showType: 0,
            siteType: 33,
            shopType: 'plus',
            currencyId: 10,
            id: 1008525836,
            domain: 'shopx4-master.giikin.com',
            recommener: 4244,
            orgCode: '102101',
            countryCode: 'KR',
            status: 0,
          },
        },
        campaignTraceConfig: {
          enable: false,
          utmSourceConfig: null,
          tracingTemplateUrl: '',
        },
        accountId: '2403542423',
        accountName: '宋-4.215',
        bidAmount: 19.88,
        bidStrategy: 'TARGET_CPA',
        budgetAmount: 20,
        budgetType: 'DAILY',
        startDate: '2025-12-19',
        endDate: null,
        status: 'ENABLED',
        campaignCriterion: null,
        geoTargetType: null,
        networkSettings: {
          targetGoogleSearch: true,
          targetSearchNetwork: true,
          targetContentNetwork: true,
          targetPartnerSearchNetwork: false,
          targetYoutube: false,
          targetGoogleTvNetwork: false,
        },
        enableAiMax: false,
        adGroups: [
          {
            name: 'KR_1004983922_精緻型男塑身衣_M|未知_18~34_测试一个受众群体『躘12.29-18:5』',
            status: 'ENABLED',
            bidStrategy: null,
            bidAmount: null,
            campaignBidStrategy: 'TARGET_CPA',
            campaignBidAmount: 19.88,
            groupCriterion: {
              target: {
                locations: [
                  {
                    id: 2410,
                    code: 'KR',
                    name: '韩国',
                    defaultExclude: false,
                    countryCode: null,
                  },
                ],
                excludeLocations: [],
                languages: [1012],
              },
              audience: {
                id: 334508536,
                resourceName: 'customers/2403542423/audiences/334508536',
                criterionResourceName: null,
                name: '测试一个受众群体',
                accountId: '2403542423',
                ageRange: {
                  undetermined: true,
                  minAge: 18,
                  maxAge: 34,
                },
                genders: ['MALE', 'UNDETERMINED'],
                userInterests: [],
                lifeEvents: null,
                detailedDemographics: null,
                customAudiences: [
                  {
                    id: 930524219,
                    resourceName: 'customers/2403542423/customAudiences/930524219',
                    title: '测试细分受众',
                    accountId: '2403542423',
                    type: 'PURCHASE_INTENT',
                    keywords: [],
                    urls: ['www.baidu.com'],
                  },
                ],
                userLists: [
                  {
                    id: 9216801373,
                    accountId: '2403542423',
                    resourceName: 'customers/2403542423/userLists/9216801373',
                    name: 'All visitors (AdWords) (system-defined)',
                    description: 'People who visited pages that contain your remarketing tags',
                    membershipStatus: 'OPEN',
                    status: 'ENABLED',
                    sizeForDisplay: 8,
                    sizeForSearch: 24,
                    eligibleForSearch: true,
                    eligibleForDisplay: true,
                    type: 'RULE_BASED',
                    lookalikeUserList: null,
                    size: '24',
                    sizeInt: 24,
                  },
                  {
                    id: 9217723931,
                    accountId: '2403542423',
                    resourceName: 'customers/2403542423/userLists/9217723931',
                    name: 'All visitors (AdWords)',
                    description: 'People who visited pages that contain your remarketing tags',
                    membershipStatus: 'OPEN',
                    status: 'ENABLED',
                    sizeForDisplay: 8,
                    sizeForSearch: 24,
                    eligibleForSearch: true,
                    eligibleForDisplay: true,
                    type: 'RULE_BASED',
                    lookalikeUserList: null,
                    size: '24',
                    sizeInt: 24,
                  },
                ],
                lookalikeUserLists: null,
              },
              keywordList: null,
            },
            optimizedTargetingEnabled: true,
            excludeDemographicExpansion: false,
            channelSetting: {
              channelType: 'ALL_CHANNELS',
              includeDisplay: false,
              discover: false,
              display: false,
              gmail: false,
              youtubeInFeed: false,
              youtubeInStream: false,
              youtubeShorts: false,
            },
            ads: [
              {
                businessName: 'shopx4-master.giikin.com',
                descriptions: ['dsds'],
                headlines: ['sds'],
                logoImages: [
                  {
                    id: '200246874760',
                    name: '631576-毛艳琴-16e231b329f83e2f061175cacae9f57a',
                    title: null,
                    resourceName: 'customers/1282037141/assets/200246874760',
                    height: 260,
                    width: 260,
                    url: 'https://tpc.googlesyndication.com/simgad/14088562101564044250',
                  },
                ],
                name: '广告1',
                status: 'ENABLED',
                type: 'DEMAND_GEN_VIDEO_RESPONSIVE_AD',
                callToAction: null,
                videoCallToActions: null,
                videoLongHeadlines: ['sdsd'],
                multiImages: null,
                videoAssets: [
                  {
                    id: null,
                    name: '633396-张永-db0de327a4346f2d03a78cd61403f2bf',
                    title: 'e5cbbbb6a9780eb6d442844a3d130caa7411374091005772373JP27d0665438e81d8eceb98c1e31fca80c1',
                    resourceName: null,
                    height: 0,
                    width: 0,
                    url: null,
                    videoId: 'Sq0QVrxRSqo',
                    youtubeChannelId: 3,
                    thumbnail: 'https://i.ytimg.com/vi/Sq0QVrxRSqo/default.jpg',
                  },
                ],
                adAssetAutoSettings: [
                  {
                    type: 'GENERATE_LANDING_PAGE_PREVIEW',
                    enabled: false,
                  },
                  {
                    type: 'GENERATE_VERTICAL_YOUTUBE_VIDEOS',
                    enabled: true,
                  },
                  {
                    type: 'GENERATE_SHORTER_YOUTUBE_VIDEOS',
                    enabled: true,
                  },
                ],
              },
              {
                businessName: 'shopx4-master.giikin.com',
                descriptions: ['dsds'],
                headlines: ['sds'],
                logoImages: [
                  {
                    id: '200246874760',
                    name: '631576-毛艳琴-16e231b329f83e2f061175cacae9f57a',
                    title: null,
                    resourceName: 'customers/1282037141/assets/200246874760',
                    height: 260,
                    width: 260,
                    url: 'https://tpc.googlesyndication.com/simgad/14088562101564044250',
                  },
                ],
                name: '广告2',
                status: 'ENABLED',
                type: 'DEMAND_GEN_VIDEO_RESPONSIVE_AD',
                callToAction: null,
                videoCallToActions: null,
                videoLongHeadlines: ['sdsd'],
                multiImages: null,
                videoAssets: [
                  {
                    id: null,
                    name: '633396-张永-db0de327a4346f2d03a78cd61403f2bf',
                    title: 'e5cbbbb6a9780eb6d442844a3d130caa7411374091005772373JP27d0665438e81d8eceb98c1e31fca80c1',
                    resourceName: null,
                    height: 0,
                    width: 0,
                    url: null,
                    videoId: 'Sq0QVrxRSqo',
                    youtubeChannelId: 3,
                    thumbnail: 'https://i.ytimg.com/vi/Sq0QVrxRSqo/default.jpg',
                  },
                ],
                adAssetAutoSettings: [
                  {
                    type: 'GENERATE_LANDING_PAGE_PREVIEW',
                    enabled: false,
                  },
                  {
                    type: 'GENERATE_VERTICAL_YOUTUBE_VIDEOS',
                    enabled: true,
                  },
                  {
                    type: 'GENERATE_SHORTER_YOUTUBE_VIDEOS',
                    enabled: true,
                  },
                ],
              },
            ],
          },
          {
            name: 'KR_1004983922_精緻型男塑身衣_M|未知_18~34_测试一个受众群体『蜤12.29-18:5』',
            status: 'ENABLED',
            bidStrategy: null,
            bidAmount: null,
            campaignBidStrategy: 'TARGET_CPA',
            campaignBidAmount: 19.88,
            groupCriterion: {
              target: {
                locations: [
                  {
                    id: 2410,
                    code: 'KR',
                    name: '韩国',
                    defaultExclude: false,
                    countryCode: null,
                  },
                ],
                excludeLocations: [],
                languages: [1012],
              },
              audience: {
                id: 334508536,
                resourceName: 'customers/2403542423/audiences/334508536',
                criterionResourceName: null,
                name: '测试一个受众群体',
                accountId: '2403542423',
                ageRange: {
                  undetermined: true,
                  minAge: 18,
                  maxAge: 34,
                },
                genders: ['MALE', 'UNDETERMINED'],
                userInterests: [],
                lifeEvents: null,
                detailedDemographics: null,
                customAudiences: [
                  {
                    id: 930524219,
                    resourceName: 'customers/2403542423/customAudiences/930524219',
                    title: '测试细分受众',
                    accountId: '2403542423',
                    type: 'PURCHASE_INTENT',
                    keywords: [],
                    urls: ['www.baidu.com'],
                  },
                ],
                userLists: [
                  {
                    id: 9216801373,
                    accountId: '2403542423',
                    resourceName: 'customers/2403542423/userLists/9216801373',
                    name: 'All visitors (AdWords) (system-defined)',
                    description: 'People who visited pages that contain your remarketing tags',
                    membershipStatus: 'OPEN',
                    status: 'ENABLED',
                    sizeForDisplay: 8,
                    sizeForSearch: 24,
                    eligibleForSearch: true,
                    eligibleForDisplay: true,
                    type: 'RULE_BASED',
                    lookalikeUserList: null,
                    size: '24',
                    sizeInt: 24,
                  },
                  {
                    id: 9217723931,
                    accountId: '2403542423',
                    resourceName: 'customers/2403542423/userLists/9217723931',
                    name: 'All visitors (AdWords)',
                    description: 'People who visited pages that contain your remarketing tags',
                    membershipStatus: 'OPEN',
                    status: 'ENABLED',
                    sizeForDisplay: 8,
                    sizeForSearch: 24,
                    eligibleForSearch: true,
                    eligibleForDisplay: true,
                    type: 'RULE_BASED',
                    lookalikeUserList: null,
                    size: '24',
                    sizeInt: 24,
                  },
                ],
                lookalikeUserLists: null,
              },
              keywordList: null,
            },
            optimizedTargetingEnabled: true,
            excludeDemographicExpansion: false,
            channelSetting: {
              channelType: 'ALL_CHANNELS',
              includeDisplay: false,
              discover: false,
              display: false,
              gmail: false,
              youtubeInFeed: false,
              youtubeInStream: false,
              youtubeShorts: false,
            },
            ads: [
              {
                businessName: 'shopx4-master.giikin.com',
                descriptions: ['dsds'],
                headlines: ['sds'],
                logoImages: [
                  {
                    id: '200246874760',
                    name: '631576-毛艳琴-16e231b329f83e2f061175cacae9f57a',
                    title: null,
                    resourceName: 'customers/1282037141/assets/200246874760',
                    height: 260,
                    width: 260,
                    url: 'https://tpc.googlesyndication.com/simgad/14088562101564044250',
                  },
                ],
                name: '广告1',
                status: 'ENABLED',
                type: 'DEMAND_GEN_VIDEO_RESPONSIVE_AD',
                callToAction: null,
                videoCallToActions: null,
                videoLongHeadlines: ['sdsd'],
                multiImages: null,
                videoAssets: [
                  {
                    id: null,
                    name: '633396-张永-db0de327a4346f2d03a78cd61403f2bf',
                    title: 'e5cbbbb6a9780eb6d442844a3d130caa7411374091005772373JP27d0665438e81d8eceb98c1e31fca80c1',
                    resourceName: null,
                    height: 0,
                    width: 0,
                    url: null,
                    videoId: 'Sq0QVrxRSqo',
                    youtubeChannelId: 3,
                    thumbnail: 'https://i.ytimg.com/vi/Sq0QVrxRSqo/default.jpg',
                  },
                ],
                adAssetAutoSettings: [
                  {
                    type: 'GENERATE_LANDING_PAGE_PREVIEW',
                    enabled: false,
                  },
                  {
                    type: 'GENERATE_VERTICAL_YOUTUBE_VIDEOS',
                    enabled: true,
                  },
                  {
                    type: 'GENERATE_SHORTER_YOUTUBE_VIDEOS',
                    enabled: true,
                  },
                ],
              },
              {
                businessName: 'shopx4-master.giikin.com',
                descriptions: ['dsds'],
                headlines: ['sds'],
                logoImages: [
                  {
                    id: '200246874760',
                    name: '631576-毛艳琴-16e231b329f83e2f061175cacae9f57a',
                    title: null,
                    resourceName: 'customers/1282037141/assets/200246874760',
                    height: 260,
                    width: 260,
                    url: 'https://tpc.googlesyndication.com/simgad/14088562101564044250',
                  },
                ],
                name: '广告2',
                status: 'ENABLED',
                type: 'DEMAND_GEN_VIDEO_RESPONSIVE_AD',
                callToAction: null,
                videoCallToActions: null,
                videoLongHeadlines: ['sdsd'],
                multiImages: null,
                videoAssets: [
                  {
                    id: null,
                    name: '633396-张永-db0de327a4346f2d03a78cd61403f2bf',
                    title: 'e5cbbbb6a9780eb6d442844a3d130caa7411374091005772373JP27d0665438e81d8eceb98c1e31fca80c1',
                    resourceName: null,
                    height: 0,
                    width: 0,
                    url: null,
                    videoId: 'Sq0QVrxRSqo',
                    youtubeChannelId: 3,
                    thumbnail: 'https://i.ytimg.com/vi/Sq0QVrxRSqo/default.jpg',
                  },
                ],
                adAssetAutoSettings: [
                  {
                    type: 'GENERATE_LANDING_PAGE_PREVIEW',
                    enabled: false,
                  },
                  {
                    type: 'GENERATE_VERTICAL_YOUTUBE_VIDEOS',
                    enabled: true,
                  },
                  {
                    type: 'GENERATE_SHORTER_YOUTUBE_VIDEOS',
                    enabled: true,
                  },
                ],
              },
            ],
          },
          {
            name: 'KR_1004983922_精緻型男塑身衣_M|未知_18~34_测试一个受众群体『髃12.29-18:5』',
            status: 'ENABLED',
            bidStrategy: null,
            bidAmount: null,
            campaignBidStrategy: 'TARGET_CPA',
            campaignBidAmount: 19.88,
            groupCriterion: {
              target: {
                locations: [
                  {
                    id: 2410,
                    code: 'KR',
                    name: '韩国',
                    defaultExclude: false,
                    countryCode: null,
                  },
                ],
                excludeLocations: [],
                languages: [1012],
              },
              audience: {
                id: 334508536,
                resourceName: 'customers/2403542423/audiences/334508536',
                criterionResourceName: null,
                name: '测试一个受众群体',
                accountId: '2403542423',
                ageRange: {
                  undetermined: true,
                  minAge: 18,
                  maxAge: 34,
                },
                genders: ['MALE', 'UNDETERMINED'],
                userInterests: [],
                lifeEvents: null,
                detailedDemographics: null,
                customAudiences: [
                  {
                    id: 930524219,
                    resourceName: 'customers/2403542423/customAudiences/930524219',
                    title: '测试细分受众',
                    accountId: '2403542423',
                    type: 'PURCHASE_INTENT',
                    keywords: [],
                    urls: ['www.baidu.com'],
                  },
                ],
                userLists: [
                  {
                    id: 9216801373,
                    accountId: '2403542423',
                    resourceName: 'customers/2403542423/userLists/9216801373',
                    name: 'All visitors (AdWords) (system-defined)',
                    description: 'People who visited pages that contain your remarketing tags',
                    membershipStatus: 'OPEN',
                    status: 'ENABLED',
                    sizeForDisplay: 8,
                    sizeForSearch: 24,
                    eligibleForSearch: true,
                    eligibleForDisplay: true,
                    type: 'RULE_BASED',
                    lookalikeUserList: null,
                    size: '24',
                    sizeInt: 24,
                  },
                  {
                    id: 9217723931,
                    accountId: '2403542423',
                    resourceName: 'customers/2403542423/userLists/9217723931',
                    name: 'All visitors (AdWords)',
                    description: 'People who visited pages that contain your remarketing tags',
                    membershipStatus: 'OPEN',
                    status: 'ENABLED',
                    sizeForDisplay: 8,
                    sizeForSearch: 24,
                    eligibleForSearch: true,
                    eligibleForDisplay: true,
                    type: 'RULE_BASED',
                    lookalikeUserList: null,
                    size: '24',
                    sizeInt: 24,
                  },
                ],
                lookalikeUserLists: null,
              },
              keywordList: null,
            },
            optimizedTargetingEnabled: true,
            excludeDemographicExpansion: false,
            channelSetting: {
              channelType: 'ALL_CHANNELS',
              includeDisplay: false,
              discover: false,
              display: false,
              gmail: false,
              youtubeInFeed: false,
              youtubeInStream: false,
              youtubeShorts: false,
            },
            ads: [
              {
                businessName: 'shopx4-master.giikin.com',
                descriptions: ['dsds'],
                headlines: ['sds'],
                logoImages: [
                  {
                    id: '200246874760',
                    name: '631576-毛艳琴-16e231b329f83e2f061175cacae9f57a',
                    title: null,
                    resourceName: 'customers/1282037141/assets/200246874760',
                    height: 260,
                    width: 260,
                    url: 'https://tpc.googlesyndication.com/simgad/14088562101564044250',
                  },
                ],
                name: '广告1',
                status: 'ENABLED',
                type: 'DEMAND_GEN_VIDEO_RESPONSIVE_AD',
                callToAction: null,
                videoCallToActions: null,
                videoLongHeadlines: ['sdsd'],
                multiImages: null,
                videoAssets: [
                  {
                    id: null,
                    name: '633396-张永-db0de327a4346f2d03a78cd61403f2bf',
                    title: 'e5cbbbb6a9780eb6d442844a3d130caa7411374091005772373JP27d0665438e81d8eceb98c1e31fca80c1',
                    resourceName: null,
                    height: 0,
                    width: 0,
                    url: null,
                    videoId: 'Sq0QVrxRSqo',
                    youtubeChannelId: 3,
                    thumbnail: 'https://i.ytimg.com/vi/Sq0QVrxRSqo/default.jpg',
                  },
                ],
                adAssetAutoSettings: [
                  {
                    type: 'GENERATE_LANDING_PAGE_PREVIEW',
                    enabled: false,
                  },
                  {
                    type: 'GENERATE_VERTICAL_YOUTUBE_VIDEOS',
                    enabled: true,
                  },
                  {
                    type: 'GENERATE_SHORTER_YOUTUBE_VIDEOS',
                    enabled: true,
                  },
                ],
              },
              {
                businessName: 'shopx4-master.giikin.com',
                descriptions: ['dsds'],
                headlines: ['sds'],
                logoImages: [
                  {
                    id: '200246874760',
                    name: '631576-毛艳琴-16e231b329f83e2f061175cacae9f57a',
                    title: null,
                    resourceName: 'customers/1282037141/assets/200246874760',
                    height: 260,
                    width: 260,
                    url: 'https://tpc.googlesyndication.com/simgad/14088562101564044250',
                  },
                ],
                name: '广告2',
                status: 'ENABLED',
                type: 'DEMAND_GEN_VIDEO_RESPONSIVE_AD',
                callToAction: null,
                videoCallToActions: null,
                videoLongHeadlines: ['sdsd'],
                multiImages: null,
                videoAssets: [
                  {
                    id: null,
                    name: '633396-张永-db0de327a4346f2d03a78cd61403f2bf',
                    title: 'e5cbbbb6a9780eb6d442844a3d130caa7411374091005772373JP27d0665438e81d8eceb98c1e31fca80c1',
                    resourceName: null,
                    height: 0,
                    width: 0,
                    url: null,
                    videoId: 'Sq0QVrxRSqo',
                    youtubeChannelId: 3,
                    thumbnail: 'https://i.ytimg.com/vi/Sq0QVrxRSqo/default.jpg',
                  },
                ],
                adAssetAutoSettings: [
                  {
                    type: 'GENERATE_LANDING_PAGE_PREVIEW',
                    enabled: false,
                  },
                  {
                    type: 'GENERATE_VERTICAL_YOUTUBE_VIDEOS',
                    enabled: true,
                  },
                  {
                    type: 'GENERATE_SHORTER_YOUTUBE_VIDEOS',
                    enabled: true,
                  },
                ],
              },
            ],
          },
        ],
        uploadNow: false,
      },
    };
  },
  computed: {
    // 合并传入数据和默认数据
    mergedData() {
      // 优先使用本地数据
      if (this.localData) {
        return this.localData;
      }
      const hasValidData = this.splitTableMsg && this.splitTableMsg.adGroups && this.splitTableMsg.adGroups.length > 0;

      if (hasValidData) {
        return this.splitTableMsg;
      }
      return this.defaultData;
    },
  },
  watch: {
    splitTableMsg: {
      handler(val) {
        // 当 prop 变化时，更新本地数据
        if (val && val.adGroups && val.adGroups.length > 0) {
          this.localData = JSON.parse(JSON.stringify(val));
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleSectionChange(section) {
      this.activeSection = section;
    },

    // 更新广告系列
    handleUpdateCampaign({ field, value }) {
      const updatedData = {
        ...this.mergedData,
        [field]: value,
      };
      this.localData = updatedData;
      this.$emit('update-data', updatedData);
    },

    // 更新广告系列数据（预算、出价等整体数据）
    handleUpdateCampaignData(val) {
      // 合并更新的数据到当前数据
      let updatedData = {
        ...this.mergedData,
        ...val,
      };

      // 如果系列出价或出价策略发生变化，同步更新所有广告组的 campaignBidAmount 和 campaignBidStrategy
      if (val.bidAmount !== undefined || val.bidStrategy !== undefined) {
        const updatedAdGroups = (updatedData.adGroups || []).map((adGroup) => ({
          ...adGroup,
          campaignBidAmount: val.bidAmount !== undefined ? val.bidAmount : adGroup.campaignBidAmount,
          campaignBidStrategy: val.bidStrategy !== undefined ? val.bidStrategy : adGroup.campaignBidStrategy,
        }));
        updatedData = {
          ...updatedData,
          adGroups: updatedAdGroups,
        };
      }

      this.localData = updatedData;
      this.$emit('update-data', updatedData);
    },

    // 更新广告组
    handleUpdateAdGroup({ groupIndex, field, value }) {
      const updatedAdGroups = [...this.mergedData.adGroups];
      updatedAdGroups[groupIndex] = {
        ...updatedAdGroups[groupIndex],
        [field]: value,
      };

      const updatedData = {
        ...this.mergedData,
        adGroups: updatedAdGroups,
      };
      this.localData = updatedData;
      this.$emit('update-data', updatedData);
    },

    // 删除广告组
    handleDeleteAdGroup(groupIndex) {
      if (this.mergedData.adGroups.length <= 1) {
        this.$message.warning('至少需要保留一个广告组');
        return;
      }

      const updatedAdGroups = this.mergedData.adGroups.filter((_, index) => index !== groupIndex);

      const updatedData = {
        ...this.mergedData,
        adGroups: updatedAdGroups,
      };
      this.localData = updatedData;
      this.$emit('update-data', updatedData);

      // 如果删除的是当前选中的广告组，切换到系列视图
      if (this.activeSection === `adGroup-${groupIndex}`) {
        this.activeSection = 'campaign';
      }
    },

    // 更新广告
    handleUpdateAd({ groupIndex, adIndex, field, value }) {
      const updatedAdGroups = [...this.mergedData.adGroups];
      const updatedAds = [...updatedAdGroups[groupIndex].ads];
      updatedAds[adIndex] = {
        ...updatedAds[adIndex],
        [field]: value,
      };

      updatedAdGroups[groupIndex] = {
        ...updatedAdGroups[groupIndex],
        ads: updatedAds,
      };

      const updatedData = {
        ...this.mergedData,
        adGroups: updatedAdGroups,
      };
      this.localData = updatedData;
      this.$emit('update-data', updatedData);
    },

    // 删除广告
    handleDeleteAd({ groupIndex, adIndex }) {
      const adGroup = this.mergedData.adGroups[groupIndex];
      if (!adGroup.ads || adGroup.ads.length <= 1) {
        this.$message.warning('每个广告组至少需要保留一个广告');
        return;
      }

      const updatedAdGroups = [...this.mergedData.adGroups];
      const updatedAds = updatedAdGroups[groupIndex].ads.filter((_, index) => index !== adIndex);

      updatedAdGroups[groupIndex] = {
        ...updatedAdGroups[groupIndex],
        ads: updatedAds,
      };

      const updatedData = {
        ...this.mergedData,
        adGroups: updatedAdGroups,
      };
      this.localData = updatedData;
      this.$emit('update-data', updatedData);
    },

    // 添加新广告组
    handleAddAdGroup() {
      const newAdGroup = {
        name: `广告组 ${this.mergedData.adGroups.length + 1}`,
        status: 'ENABLED',
        bidStrategy: 'TARGET_CPA',
        bidAmount: 6.5,
        budgetAmount: 20,
        locations: [
          { id: 2840, name: '美国' },
          { id: 2124, name: '加拿大' },
        ],
        languages: [{ id: 1000, name: '英语' }],
        interests: [
          { id: 80432, name: '购物爱好者' },
          { id: 80433, name: '时尚达人' },
        ],
        ageRanges: ['AGE_RANGE_18_24', 'AGE_RANGE_25_34'],
        genders: ['MALE', 'FEMALE'],
        optimizedTargeting: true,
        ads: [
          {
            name: '新广告 1',
            status: 'ENABLED',
            type: 'DEMAND_GEN_VIDEO_RESPONSIVE_AD',
            headlines: ['新广告标题', '吸引眼球', '立即行动'],
            descriptions: ['新广告描述内容', '优质产品等你发现'],
            businessName: '品牌旗舰店',
            finalUrl: 'https://www.example.com/new-landing',
            callToAction: 'SHOP_NOW',
            videoAssets: [
              {
                videoId: 'new_video_001',
                name: '新视频素材',
                title: '新视频标题',
                youtubeChannelId: 'UC_new_channel',
                duration: 15,
              },
            ],
            imageAssets: [{ name: '新横幅图片', url: 'https://example.com/new-banner.jpg' }],
          },
        ],
      };

      const updatedAdGroups = [...this.mergedData.adGroups, newAdGroup];

      const updatedData = {
        ...this.mergedData,
        adGroups: updatedAdGroups,
      };
      this.localData = updatedData;
      this.$emit('update-data', updatedData);
    },

    // 添加新广告
    handleAddAd(groupIndex) {
      const newAd = {
        name: `新广告 ${this.mergedData.adGroups[groupIndex].ads.length + 1}`,
        status: 'ENABLED',
        type: 'DEMAND_GEN_VIDEO_RESPONSIVE_AD',
        headlines: ['新广告标题', '精彩内容', '不容错过'],
        descriptions: ['新广告描述', '优质体验从这里开始'],
        businessName: '品牌旗舰店',
        finalUrl: 'https://www.example.com/new-ad-landing',
        callToAction: 'LEARN_MORE',
        videoAssets: [
          {
            videoId: 'new_video_ad',
            name: '新视频素材',
            title: '新视频标题',
            youtubeChannelId: 'UC_new_channel',
            duration: 20,
          },
        ],
        imageAssets: [{ name: '新广告图片', url: 'https://example.com/new-ad-image.jpg' }],
      };

      const updatedAdGroups = [...this.mergedData.adGroups];
      const updatedAds = [...updatedAdGroups[groupIndex].ads, newAd];

      updatedAdGroups[groupIndex] = {
        ...updatedAdGroups[groupIndex],
        ads: updatedAds,
      };

      const updatedData = {
        ...this.mergedData,
        adGroups: updatedAdGroups,
      };
      this.localData = updatedData;
      this.$emit('update-data', updatedData);
    },
    // 对外提供的验证方法
    validate() {
      if (this.$refs.fullDataPanel && this.$refs.fullDataPanel.validate) {
        return this.$refs.fullDataPanel.validate();
      }
      return Promise.resolve(true);
    },
  },
};
</script>

<style lang="scss" scoped>
.preview-container {
  height: calc(100vh - 230px);
  min-height: 400px;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.left-nav {
  min-width: 256px;
  height: 100%;
  overflow: hidden;
  background: #ffffff;
  border-right: 2px solid #f0f0f0;
}

.right-content {
  height: 100%;
  overflow: hidden;
  background: #f8f9fa;
}
</style>
